.container {
  height: 4rem;
  min-height: 4rem;
  border-bottom: 1px var(--content-border-color) solid;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.6rem;
}

.left {
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
  align-items: center;
}

.tools {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;
  color: var(--color-texts-high-contrast);

  & button:not(div#download-share-button button) {
    background-color: var(--color-surfaces-bg-elevation-1);
    color: var(--color-texts-high-contrast);

    & svg {
      width: 1.6rem;
      height: 1.6rem;
      stroke: unset;
      fill: unset;
      color: var(--color-texts-high-contrast);
    }

    &:hover:enabled,
    &:focus:enabled,
    &:active:enabled {
      background-color: var(--color-surfaces-bg-elevation-2);

      & > svg {
        stroke: unset;
        fill: unset;
      }
    }
  }
}
